import { dictionaryList } from '../../../config/languages';
import { setConfigStateById } from '../ConfigContext';

export const setLanguage = (setState: setConfigStateById) => (language: string) => {
  setState('SET_LANGUAGE', (s) => ({
    ...s,
    language,
    dictionaryValues: dictionaryList[language][s.registry],
  }));
};
